export default "__VITE_ASSET__DlWTeEoJ__"